// extracted by mini-css-extract-plugin
export default {"background":"globalStyles_background__iRmc6"};